import { render, staticRenderFns } from "./FilterSummaryShinTapirLeaf.vue?vue&type=template&id=38ab599a&"
import script from "./FilterSummaryShinTapirLeaf.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryShinTapirLeaf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports